
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.594 24c-6.242 0-7.194-3.201-7.194-3.201s-1.216-4.152-.618-9.934c-.464-.218-1.124-.465-1.782-.465-.68 0-1.344.25-1.802.47.596 5.78-.598 9.93-.598 9.93S8.8 24 2.4 24C.748 24 0 21.962 0 20.8 0 5.5 7.915-.2 9.6 7.2c.157.689.277 1.357.38 2.016.325-.326.8-.803 1.22-1.215V0h1.6v8l1.202 1.2c.102-.647.22-1.303.375-1.979C16.066-.169 24 5.525 24 20.803 24 21.964 23.25 24 21.594 24z","fill":"#fff"}})])
          )
        }
      }
    